
export const COUNTRY_OPTIONS = [
  "Australia",
  "Bahamas",
  "Bermuda",
  "Brazil",
  "British Virgin Islands",
  "Canada",
  "Cayman Islands",
  "China",
  "Colombia",
  "Cyprus",
  "Dominican Republic",
  "Finland",
  "Germany",
  "Gibraltar",
  "Guernsey",
  "Indonesia",
  "Ireland",
  "Isle of Man",
  "Japan",
  "Jersey",
  "Liberia",
  "Luxembourg",
  "Mexico",
  "Mongolia",
  "North Macedonia",
  "Norway",
  "Papua New Guinea",
  "Peru",
  "Poland",
  "Saudi Arabia",
  "South Africa",
  "South Korea",
  "Spain",
  "Sweden",
  "Switzerland",
  "Turkey",
  "United Kingdom",
  "United States",
];

export const ALLOWED_STAGED_COMPANY_FIELDS = [
  "name",
  "tickers_exchanges",
  "corporate_structure",
  "company_type",
  "company_lifecycle",
  "company_lifecycle_stage",
  "commodities",
  "hq_country",
  "hq_city",
  "website_url",
  "contact_email",
  "contact_phone",
  "year_founded",
  "corporate_description",
  "recent_news_link",
  "corporate_presentation",
  "featured_video_link",
];

export const COMPANY_TYPE_OPTIONS = [
  { value: "mining", label: "Mining" },
  { value: "royalty_streaming", label: "Royalty/Streaming" },
];

export const CORPORATE_STRUCTURE_OPTIONS = [
  { value: "public", label: "Public" },
  { value: "private", label: "Private" },
  { value: "state-owned", label: "State-Owned" },
];

export const COMPANY_LIFECYCLE_OPTIONS = [
  { value: "exploration", label: "Exploration" },
  { value: "development", label: "Development" },
  { value: "production", label: "Production" },
  { value: "closure", label: "Closure" },
  { value: "na", label: "N/A" },
];

export const COMPANY_LIFECYCLE_STAGE_OPTIONS = [
  { value: "exploration_targeting", label: "Exploration/Targeting", lifecycle: "exploration" },
  { value: "discovery", label: "Discovery", lifecycle: "exploration" },
  { value: "resource_definition", label: "Resource Definition", lifecycle: "exploration" },
  { value: "scoping_pea", label: "Scoping/PEA", lifecycle: "development" },
  { value: "pfs", label: "PFS", lifecycle: "development" },
  { value: "fs_bfs", label: "FS/BFS", lifecycle: "development" },
  { value: "permitting", label: "Permitting", lifecycle: "development" },
  { value: "financing", label: "Financing", lifecycle: "development" },
  { value: "construction", label: "Construction", lifecycle: "development" },
  { value: "commissioning_ramp", label: "Commissioning/Ramp", lifecycle: "development" },
  { value: "early", label: "Early", lifecycle: "production" },
  { value: "mid", label: "Mid", lifecycle: "production" },
  { value: "late", label: "Late", lifecycle: "production" },
  { value: "rehabilitation", label: "Rehabilitation", lifecycle: "closure" },
  { value: "long_term_monitoring", label: "Long-term Monitoring", lifecycle: "closure" },
  { value: "closure_stage", label: "Closure", lifecycle: "closure" },
];

export const VALID_STAGES_BY_LIFECYCLE = {
  exploration: ["exploration_targeting", "discovery", "resource_definition"],
  development: [
    "scoping_pea",
    "pfs",
    "fs_bfs",
    "permitting",
    "financing",
    "construction",
    "commissioning_ramp",
  ],
  production: ["early", "mid", "late"],
  closure: ["rehabilitation", "long_term_monitoring", "closure_stage"],
};
